import React, { useState } from 'react';
import { array, bool, node, object, string } from 'prop-types';
import classNames from 'classnames';
import { propTypes } from '../../../util/types';
import { FavoritesModal, PaginationLinks } from '../../../components';
import css from './SearchResultsPanel.module.css';
import { getCardComponent, getListingCategory } from '../../../util/searchPageHelpers';
import { cardRenderSizes } from '../../../util/genericHelpers';
import { UserType } from '../../../util/enums';
import { useSelector } from 'react-redux';
import { userSelector } from '../../../ducks/user.duck';

const SearchResultsPanel = props => {
  const {
    className,
    rootClassName,
    listings,
    pagination,
    search,
    setActiveListing,
    isMapVariant,
  } = props;
  const currentUser = useSelector(userSelector);
  const currentUserId = currentUser?.id?.uuid;
  const classes = classNames(rootClassName || css.root, className);

  const [activeFavoriteId, setActiveFavoriteId] = useState(null);
  const [firstImage, setFirstImage] = useState(null);
  const openFavoritesModal = id => setActiveFavoriteId(id);
  const paginationLinks =
    pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName="SearchPage"
        pageSearchParams={search}
        pagination={pagination}
      />
    ) : null;

  const renderListingCard = (listing, isMapVariant, setActiveListing) => {
    try {
      if (!listing?.id?.uuid) {
        console.warn('Invalid listing provided:', listing);
        return null;
      }

      const category = getListingCategory(listing);
      const CardComponent = getCardComponent(category);
      return (
        <CardComponent
          className={css.listingCard}
          key={listing.id.uuid}
          listing={listing}
          renderSizes={cardRenderSizes(isMapVariant)}
          setActiveListing={setActiveListing}
          isSearchPage={true}
          openFavoritesModal={openFavoritesModal}
          activeFavoriteId={activeFavoriteId}
          setActiveFavoriteId={setActiveFavoriteId}
          setFirstImage={setFirstImage}
        />
      );
    } catch (error) {
      console.error('Error rendering listing card:', error);
      return null;
    }
  };
  const firstCategory = listings && listings.length > 0 ? getListingCategory(listings[0]) : null;
  return (
    <div className={classes}>
      <div
        className={classNames(
          isMapVariant ? css.listingCardsMapVariant : css.listingCards,
          firstCategory === UserType.TALENT ? css.talentListings : null
        )}
      >
        {listings.map(l => renderListingCard(l, isMapVariant, setActiveListing))}
        {props.children}
        <FavoritesModal
          isOpen={!!activeFavoriteId}
          onClose={() => setActiveFavoriteId(null)}
          firstImage={firstImage}
          currentUserId={currentUserId}
          activeFavoriteId={activeFavoriteId}
        />
      </div>
      {paginationLinks}
    </div>
  );
};

SearchResultsPanel.defaultProps = {
  children: null,
  className: null,
  listings: [],
  pagination: null,
  rootClassName: null,
  search: null,
  isMapVariant: true,
};

SearchResultsPanel.propTypes = {
  children: node,
  className: string,
  listings: array,
  pagination: propTypes.pagination,
  rootClassName: string,
  search: object,
  isMapVariant: bool,
};

export default SearchResultsPanel;
